import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../../store';
import { closeFeedbackPopup } from '../../../actions/feedback';
import { FeedbackPopup } from './FeedbackPopup';

export const FeedbackPopupContainer = connect(
  (state: IState) => ({
    isOpen: state.feedback.isPopupOpened,
  }),
  (dispatch: Dispatch<{}>) => ({
    onClose() {
      dispatch(closeFeedbackPopup());
    },
  }),
)(FeedbackPopup);
